import C from './component';

export * from './component';

export default C;
